﻿
window.addEventListener('load', () => {

    // switch desktop/mobile checkout

    function toggleCartLayout() {
        const cartSidebar = document.querySelector('.checkout-summary-content .cart-sidebar'); // cart list in sticky cart
        const checkoutContent = document.querySelector('.checkout-content'); // desktop cart 
        const checkoutSummaryContent = document.querySelector('.checkout-summary-content'); // sticky cart 

        if (cartSidebar && checkoutContent && checkoutSummaryContent) {

            if (!window.matchMedia("(max-width: 990px)").matches) {
                checkoutContent.appendChild(cartSidebar);
            }

            window.addEventListener('resize', () => {
                if (window.matchMedia("(max-width: 990px)").matches) {
                    checkoutSummaryContent.appendChild(cartSidebar);
                } else {
                    checkoutContent.appendChild(cartSidebar);
                }
            });

        }
    }

    // ----- checkout summary show-hide

    function toggleCheckoutSummary() {

        const checkoutSummaryHeader = document.querySelector('.checkout-summary-header');

        if (!checkoutSummaryHeader) {
            return;
        }

        checkoutSummaryHeader.addEventListener('click', () => {

            const toggle = checkoutSummaryHeader.querySelector('.checkout-summary-header-toggle');

            if (checkoutSummaryHeader.nextElementSibling) {
                checkoutSummaryHeader.nextElementSibling.classList.toggle('visible');
            }

            if (toggle) {
                toggle.classList.toggle('content-visible');
            }
        });
    }

    toggleCartLayout()
    toggleCheckoutSummary();
});